import React from 'react';
import Card from '../../../../muiComponents/Card';
import { useHistoryBookingsKPIs } from '../../../../contexts/DashboardContext';
import useTranslate from '../../../../customHooks/useTranslate';
import Tooltip from '../../../../muiComponents/Tooltip';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';

const KPIs = () => {
    const translate = useTranslate();
    const {
        totalConfirmed,
        totalCancelled,
        cancelledPercentage,
        totalNights,
        los,
        period,
        isLoading,
        isDataAvailable,
    } = useHistoryBookingsKPIs();

    if (isLoading) {
        return (
            <div className='dashboard__kpi-list'>
                {Array.from({ length: 6 }).map((_, index) => (
                    <Card className='padding20 kpi-list__item' key={index}>
                        <LoadingPlaceholder
                            variant='rounded'
                            width={'100%'}
                            height={'100%'}
                        />
                    </Card>
                ))}
            </div>
        );
    }

    return (
        <div className='dashboard__kpi-list'>
            {/* Row 1 — totals */}
            <Card className='padding20 kpi-list__item'>
                <p className='kpi-list__item__title'>
                    {translate('confirmed_bookings')}
                </p>
                <p className='kpi-list__item__value'>
                    {isDataAvailable ? totalConfirmed : '-'}
                </p>
                <p className='kpi-list__item__subtitle'>
                    {isDataAvailable
                        ? translate(period.key)
                        : translate('no_data_for_period')}
                </p>
            </Card>
            <Card className='padding20 kpi-list__item'>
                <p className='kpi-list__item__title'>
                    {translate('total_nights')}
                </p>
                <p className='kpi-list__item__value'>
                    {isDataAvailable ? totalNights : '-'}
                </p>
                <p
                    className={`kpi-list__item__subtitle ${
                        isDataAvailable ? 'kpi--positive' : ''
                    }`}
                >
                    {isDataAvailable
                        ? translate('confirmed_only')
                        : translate('no_data_for_period')}
                </p>
            </Card>
            {/* Row 2 — derived rates */}
            <Card className='padding20 kpi-list__item'>
                <p className='kpi-list__item__title'>
                    {translate('cancelled_bookings')}
                </p>
                <p className='kpi-list__item__value'>
                    {isDataAvailable ? totalCancelled : '-'}
                </p>
                <p
                    className={`kpi-list__item__subtitle  ${
                        isDataAvailable ? 'kpi--negative' : ''
                    }`}
                >
                    {isDataAvailable
                        ? `${cancelledPercentage.toFixed(2)}% ${translate(
                              'cancellation_rate'
                          )}`
                        : translate('no_data_for_period')}
                </p>
            </Card>
            <Card className='padding20 kpi-list__item'>
                <Tooltip
                    title={translate('length_of_stay')}
                    placement='top-start'
                >
                    <p className='kpi-list__item__title cursor-pointer'>
                        {translate('los')}
                    </p>
                </Tooltip>
                <p className='kpi-list__item__value'>
                    {isDataAvailable ? los.toFixed(1) : '-'}
                </p>
                <p className='kpi-list__item__subtitle'>
                    {isDataAvailable
                        ? `${translate(
                              'avg_nights_per_booking'
                          )}: ${los.toFixed(1)}`
                        : translate('no_data_for_period')}
                </p>
            </Card>
        </div>
    );
};

export default KPIs;
